import {
  useLazyGetApiV1UsersByUserIdFollowersQuery,
  isHiddenListError,
} from '@wellesley/user'
import useInfiniteLazyQuery from '../useInfiniteLazyQuery'

type HookProps = {
  userId?: string
  skip?: boolean
}

const PAGE_SIZE = 50

const useLocalFollowersInfinite = ({ userId, skip = false }: HookProps) => {
  const {
    items,
    isLoading,
    error,
    isFetchingNext,
    hasNextPage,
    fetchNextPage,
  } = useInfiniteLazyQuery({
    useLazyQueryHook: useLazyGetApiV1UsersByUserIdFollowersQuery,
    initialArg: {
      userId: userId!,
      limit: PAGE_SIZE,
      offset: 0,
    },
    skip: skip || !userId,
    getNextArg: (currentData, currentArg) => {
      if (
        !currentData ||
        currentData.length < PAGE_SIZE ||
        typeof currentArg?.offset !== 'number'
      ) {
        return null
      }

      return {
        ...currentArg,
        offset: currentArg.offset + PAGE_SIZE,
      }
    },
    withLocalState: true,
  })

  return {
    followers: items,
    isLoading,
    isHidden: isHiddenListError(error),
    isFetchingNext,
    hasNextPage,
    fetchNextPage,
  }
}

export default useLocalFollowersInfinite
